import { CacheService } from 'app/shared/services/cache/cache.service';

import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'complete-modal-page',
	template: `
		<div class="relative border flex flex-col h-screen text-center">
			<div class="mx-auto p-5">
				<h1 class="text-2xl font-semibold">{{ title }}</h1>
				<p
					[innerHTML]="message"
					class="mt-4 max-w-3xl mx-auto text-left text-base gt-xs:text-xl text-black"
				></p>
			</div>
		</div>
	`,
})
export class CompleteModalPage implements OnInit {
	@Input('title') title: string = '';
	@Input('message') message: string = '';
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor() {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - ngOnInit
	 **-------------------------------------------------------------------------------------
	 */
	ngOnInit() {}
}
